import * as React from 'react';
import {
  FlexLayout, GridLayout,
} from '../../../../../components';
import { Global, TemplateProps } from '../../../../../constants';
import { Status } from '../Status';
import { StatusDetailGridHeader } from '../headers/StatusDetailGridHeader';

/**
 * 화면 > 탭 A
 * @window w_tb_da451w_01
 * @category 설치견적현황
 */
export const StatusDetailTabTemplate: React.FC<TemplateProps<Status>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <GridLayout
      infinityHandler={scope.infinityDetail}
      header={StatusDetailGridHeader(scope)}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.dataDetail}
      onRowClick={(row) => scope.onRowClick(row)}
      onRowDoubleClick={() => scope.onClickOpenResist()}
    elGrid="dataDetail"
    />
  </FlexLayout>
);
